import React, { useEffect, useState } from 'react';
import { AlertTriangle, CheckCircle2, RefreshCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import api from '@/api/api';
import { toast } from 'sonner';

export default function GoLiveChecklist() {
  const [loading, setLoading] = useState(true);
  const [checklist, setChecklist] = useState(null);

  const loadChecklist = async () => {
    try {
      setLoading(true);
      const res = await api.get('/fleets/go-live-checklist');
      if (res.data?.success) {
        setChecklist(res.data.data.checklist);
      }
    } catch (error) {
      toast.error('Erro ao carregar checklist Go-Live');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadChecklist();
  }, []);

  if (loading) {
    return (
      <div className="p-12 bg-card rounded-xl border text-center">
        <p className="text-sm font-medium text-muted-foreground">Carregando checklist Go-Live...</p>
      </div>
    );
  }

  if (!checklist) {
    return (
      <div className="p-12 bg-card rounded-xl border text-center">
        <p className="text-sm font-medium text-destructive">Não foi possível carregar o checklist.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <p className="text-xs uppercase tracking-widest font-semibold text-primary">Compliance</p>
          <h1 className="text-2xl font-bold tracking-tight">Checklist Go-Live</h1>
          <p className="text-sm text-muted-foreground mt-1">Operações críticas são bloqueadas até concluir todos os requisitos.</p>
        </div>
        <Button onClick={loadChecklist} variant="outline">
          <RefreshCcw size={14} className="mr-2" /> Atualizar
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium text-muted-foreground">Status geral</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">Progresso</span>
            <span className="text-sm font-bold">
              {checklist.progress.completed}/{checklist.progress.total} ({checklist.progress.percentage}%)
            </span>
          </div>
          <div className="h-3 rounded-full bg-muted overflow-hidden">
            <div
              className={`h-full transition-all ${checklist.is_ready ? 'bg-emerald-500' : 'bg-amber-500'}`}
              style={{ width: `${checklist.progress.percentage}%` }}
            />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-0">
          <div className="divide-y divide-border">
            {checklist.items.map((item) => (
              <div key={item.id} className="p-6 flex items-start gap-3">
                {item.done ? (
                  <CheckCircle2 className="text-emerald-500 mt-0.5" size={18} />
                ) : (
                  <AlertTriangle className="text-amber-500 mt-0.5" size={18} />
                )}
                <div>
                  <p className="font-semibold">{item.title}</p>
                  <p className="text-xs text-muted-foreground mt-1">{item.details}</p>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {!checklist.is_ready && (
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-5">
          <p className="text-sm font-semibold text-amber-700">Go-Live pendente: importação, payout, SEPA e convites permanecem bloqueados.</p>
        </div>
      )}
    </div>
  );
}
